document.addEventListener('DOMContentLoaded', function() {
  let isScrolling = false;
  let targetScrollPosition = 0;
  
  // Keep desktop scroll exactly the same - unchanged
  function handleDesktopScroll(targetId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement) return;

    isScrolling = true;

    const headerHeight = getStickyHeaderHeight();
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });

    const newUrl = `${window.location.pathname}#${targetId}`;
    window.history.pushState({ path: newUrl }, '', newUrl);

    setTimeout(() => {
      isScrolling = false;
    }, 1000);
  }

  // Mobile scroll with position lock
  function handleMobileScroll(targetId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement) return;

    const mobileMenu = document.querySelector('.mobile-menu, .full-menu');
    const body = document.body;

    // Calculate position
    const rect = targetElement.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    targetScrollPosition = rect.top + scrollTop - 75;

    // Prevent scroll interference
    document.documentElement.style.scrollBehavior = 'auto';
    body.style.scrollBehavior = 'auto';

    // Handle menu if open
    if (mobileMenu?.classList.contains('active')) {
      mobileMenu.classList.remove('active', 'open');
      body.classList.remove('mobile-menu-active', 'menu-open');
    }

    // First scroll
    window.scrollTo(0, targetScrollPosition);

    // Lock the scroll position
    const scrollLock = (e) => {
      window.scrollTo(0, targetScrollPosition);
    };

    // Add scroll event listener to maintain position
    window.addEventListener('scroll', scrollLock);

    // Update URL
    const newUrl = `${window.location.pathname}#${targetId}`;
    window.history.pushState({ path: newUrl }, '', newUrl);

    // Remove scroll lock after a short delay
    setTimeout(() => {
      window.removeEventListener('scroll', scrollLock);
      document.documentElement.style.scrollBehavior = '';
      body.style.scrollBehavior = '';
    }, 500);
  }

  function handleNavigation(event, element) {
    event.preventDefault();
    
    const targetId = element.getAttribute('data-scroll-to');
    
    if (window.location.pathname !== '/' && window.location.pathname !== '') {
      window.location.href = `/#${targetId}`;
      return;
    }

    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (window.innerWidth < 768 && isMobileDevice) {
      handleMobileScroll(targetId);
    } else {
      handleDesktopScroll(targetId);
    }
  }

  // Attach click handlers
  document.querySelectorAll('.js-scroll-link').forEach(link => {
    link.addEventListener('click', (e) => handleNavigation(e, link));
  });

  // Handle initial hash navigation
  if (window.location.hash) {
    const targetId = window.location.hash.substring(1);
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (window.innerWidth < 768 && isMobileDevice) {
      handleMobileScroll(targetId);
    } else {
      handleDesktopScroll(targetId);
    }
  }
});